import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Button, Form, Input } from 'antd';
import { subscribe } from 'alfa';
import { withTranslation } from 'react-i18next';

import { Loading } from '../../../components/loading';
import BatchLoader from './batch-loader';
import SignWindow from '../../../components/key/sign';

class DebitsForm extends Component { // eslint-disable-line fp/no-class
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      rows: [],
      raw: '',
      validated: [],
      canProcess: false,
      signVisible: false,
    };
  }

    handleBatchDispath = () => {
      const { form } = this.props;
      form.validateFields((error, values) => {
        if (error) {
          return;
        }
        this.setState({
          description: values.description,
          signVisible: true,
        });
      });
    };

    onLoad = (parsed, rawData) => {
      this.setState({
        rows: parsed,
        raw: rawData,
        canProcess: true,
      });
    }

    payload = () => '';

    submit = () => {
      const { form } = this.props;
      form.validateFields((error, values) => {
        if (error) {
          return;
        }
        this.setState({
          description: values.description,
          signVisible: false,
        }, () => {
          const { description, raw } = this.state;
          const { onSubmit } = this.props;
          if (onSubmit) { onSubmit(description, raw); }
        });
      });
    };

    render() {
      const { t, batchOptions, form: { getFieldDecorator } } = this.props;
      const { loading, validated, canProcess, signVisible } = this.state;

      const errors = validated.filter(({ valid }) => !valid);

      return (
        <Form>
          <Loading spinning={loading}>
            <Form.Item label={t('description')} className="mb0">
              {getFieldDecorator('description', {
                rules: [{
                  required: true,
                  message: t('batch.required.desc'),
                }],
              })(
                <Input name="description" />,
              )}
            </Form.Item>

            {
              ((!validated.length) || ((validated.length > 0) && (errors.length > 0)))
                && <BatchLoader csvOptions={batchOptions} onLoad={this.onLoad} />
            }

            <Form.Item className="mt5">
              <Button
                onClick={this.submit}
                disabled={!canProcess}
                type="primary"
                htmlType="submit"
                icon="upload"
              >
                {t('create')}
              </Button>
            </Form.Item>

            <SignWindow
              visible={signVisible}
              payload={this.payload()}
              onOk={this.submit}
              onCancel={() => this.setState({ signVisible: false })}
              multiple
            />
          </Loading>
        </Form>
      );
    }
}

DebitsForm.propTypes = {
  account: PropTypes.shape({
    balance: PropTypes.shape({
      available: PropTypes.number,
    }),
    gateway_uri: PropTypes.string,
    region_id: PropTypes.string,
  }),
  batchOptions: PropTypes.object,
  business: PropTypes.shape({
    id: PropTypes.string,
  }),
  form: PropTypes.shape({
    validateFields: PropTypes.func,
    getFieldDecorator: PropTypes.func,
  }),
  onSubmit: PropTypes.func,
  t: PropTypes.func,
};

export { DebitsForm };
export default subscribe(Form.create({ name: 'batch-new' })(withTranslation()(DebitsForm)), ['business', 'account']);
